'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@morpho-org/ui-v6/client';
import { ExternalLink } from '@morpho-org/ui-v6/server';
import { Button } from '@repo/ui';
import type { VaultV1Migration } from '@/lib/procedures/vaultV1Migration.contract';
import { useTrackV1ToV2MigrationEntryViewed } from '@/lib/analytics/client/hooks/useTrackV1ToV2MigrationEntryViewed';
import { useOpenMigrationModal } from './hooks/useOpenMigrationModal';
interface UpgradeBannerProps {
  migrationTarget: VaultV1Migration;
}
const UpgradeBanner = t0 => {
  const $ = _c(5);
  const {
    migrationTarget
  } = t0;
  useTrackV1ToV2MigrationEntryViewed("vault_page_banner", migrationTarget);
  const openMigrationModal = useOpenMigrationModal(migrationTarget, "vault_page_banner");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Avatar src="https://cdn.morpho.org/assets/logos/morpho.svg" size="small" rounded={true} />;
    t2 = <span className="text-foreground min-w-0 text-sm">Upgrade your position</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-secondary-foreground col-start-2 text-xs @[20rem]:col-end-4">Upgrade to{" "}<ExternalLink href="https://morpho.org/blog/morpho-vaults-v2-a-new-standard-for-asset-curation/" underlined={true} className="text-foreground focus-visible:outline-foreground focus-visible:outline-2">Morpho Vault V2</ExternalLink>{" "}with better yield strategies, tighter risk controls and improved liquidity.</p>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== openMigrationModal) {
    t4 = <div className="@container"><div className="bg-info gap-x-xs gap-y-xs p-sm @[20rem]:gap-y-2xs grid grid-cols-[auto_1fr] items-center rounded-lg @[20rem]:grid-cols-[auto_1fr_auto]">{t1}{t2}{t3}<Button size="sm" onClick={openMigrationModal} data-testid="upgrade-banner-button" className="col-span-2 w-full @[20rem]:col-span-1 @[20rem]:col-start-3 @[20rem]:row-start-1 @[20rem]:w-auto">Upgrade</Button></div></div>;
    $[3] = openMigrationModal;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default UpgradeBanner;